import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { AuthLayout, Field } from "@/components/AuthLayout";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [pw, setPw] = useState({ p: "", c: "" });
  const [loading, setLoading] = useState(false);

  const sendCode = async (e) => {
    e?.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      toast.success("Təsdiq kodu email ünvanınıza göndərildi");
      setStep(2);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  const reset = async (e) => {
    e.preventDefault();
    if (code.length !== 6) return toast.error("6 rəqəmli kodu daxil edin");
    if (pw.p.length < 8) return toast.error("Parol minimum 8 simvol olmalıdır");
    if (pw.p !== pw.c) return toast.error("Parollar uyğun gəlmir");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { email, code, password: pw.p });
      toast.success("Parol yeniləndi. İndi daxil olun.");
      nav("/login");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Parolu sıfırla" subtitle={step === 1 ? "Email ünvanınıza 6 rəqəmli kod göndərəcəyik" : `${email} ünvanına göndərilən kodu daxil edin`}>
      {step === 1 ? (
        <form onSubmit={sendCode} className="space-y-5" data-testid="forgot-form">
          <Field label="Email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@nümunə.az" data-testid="forgot-email-input" />
          <button disabled={loading} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="send-code-btn">{loading ? "Göndərilir..." : "Kod göndər"}</button>
          <p className="text-center text-sm"><Link to="/login" className="text-[#D4AF37]" data-testid="back-login-link">Girişə qayıt</Link></p>
        </form>
      ) : (
        <form onSubmit={reset} className="space-y-6" data-testid="reset-form">
          <div className="space-y-2">
            <span className="text-xs uppercase tracking-[0.2em] text-zinc-500">Təsdiq kodu</span>
            <InputOTP maxLength={6} value={code} onChange={setCode} data-testid="reset-code-input">
              <InputOTPGroup>
                {[0, 1, 2, 3, 4, 5].map((i) => <InputOTPSlot key={i} index={i} className="h-14 w-12 text-xl font-display border-white/15 bg-white/5" />)}
              </InputOTPGroup>
            </InputOTP>
          </div>
          <Field label="Yeni parol (min. 8 simvol)" type="password" required value={pw.p} onChange={(e) => setPw({ ...pw, p: e.target.value })} data-testid="reset-password-input" />
          <Field label="Yeni parolu təkrarlayın" type="password" required value={pw.c} onChange={(e) => setPw({ ...pw, c: e.target.value })} data-testid="reset-confirm-input" />
          <button disabled={loading} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="reset-submit-btn">{loading ? "Gözləyin..." : "Parolu yenilə"}</button>
          <button type="button" onClick={sendCode} disabled={loading} className="w-full text-sm text-[#D4AF37]" data-testid="resend-code-btn">Kodu yenidən göndər</button>
        </form>
      )}
    </AuthLayout>
  );
}
